<template>
  <div>
    <vs-breadcrumb
      class="mb-6"
      :items="[
        {
          title: '推单管理',
          url: '/tax/list',
        },
        {
          title: '支付设置',
          active: true,
        },
      ]"
    ></vs-breadcrumb>

    <div
      style="
        background-color: white;
        border-radius: 5px;
        padding: 15px;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
      "
    >
      <span style="margin-right: 20px">支付方式&nbsp;:</span>
      <vs-radio
        v-model="paySetting"
        v-for="item in payOptions"
        :vs-value="item.value"
        :key="item.value"
        style="margin-right: 10px; height: 20px"
        >{{ item.name }}</vs-radio
      >
      <vs-button size="medium" style="margin-left: 10px" @click="save"
        >保存</vs-button
      >
    </div>
  </div>
</template>

<script>
import { getPaySetting, paySettingUpdate } from '@/repo/pay.js'
export default {
  data() {
    return {
      confrimModal: false,
      btnDisabled: false,
      payOptions: [
        { name: '摩宝支付', value: 'mobaov2' },
        { name: '新生支付', value: 'xinsheng' },
        { name: '通联支付', value: 'tonglian' },
      ],
      paySetting: '',
    }
  },

  created() {
    this.getData()
  },

  methods: {
    save() {
      if (!this.paySetting) {
        this.openNotify('请选择支付方式')
        return
      }
      let params = {
        code: 'default_payment',
        value: this.paySetting,
      }
      paySettingUpdate(params, (error, res) => {
        if (error && res.msg) {
          this.openNotify(res.msg)
        } else if (res && res.code === 0) {
          this.openNotify('修改成功', 'success')
        } else {
          this.openNotify(res.msg || '修改失败')
        }
        this.getData()
      })
      console.log('保存设置')
    },
    openNotify: function (msg, color = 'danger') {
      this.$vs.notify({
        position: 'bottom-center',
        color: color,
        title: '操作提示',
        text: msg,
      })
      return false
    },
    getData() {
      this.$vs.loading()
      getPaySetting({ page: 1, per_page: 1000 }, (error, res) => {
        if (error && res.msg) {
          this.openNotify(res.msg)
        } else if (res && res.code === 0) {
          this.$vs.loading.close()
          console.log('支付设置', error, res)
          if (res.data && res.data.data) {
            res.data.data.some((item) => {
              if (item.code == 'default_payment') {
                this.paySetting = item.value
                return true
              }
            })
          }
        } else {
          this.openNotify('获取支付设置失败')
        }
      })
    },
  },
}
</script>
